import { ajaxInstance} from "../utils/axios";


export default function useTx(){
    let getAllTxsUrl = `api/transactions/list`
    let sendTxsFileUrl = `/api/transactions/store`


    const getAllTx = (currentPage, size=null, search=null) => {
        let params = {
            ...(currentPage !== null && {page: currentPage}),
            ...(size !== null && {size: size}),
            ...(search !== null && {search: search})
        }
        return new Promise((resolve, reject) => {
            ajaxInstance.get(getAllTxsUrl, { params: params
            }).then((response) => {
                const data = response.data
                console.log('Get txHook', data.data)
                if (response.status === 200){
                    resolve(data.data)
                }
            }).catch((error) => {
                if (error.response.status !== 500){
                    const data = error.response.data
                    const errors = data.errors
                    console.log('Error in get txHook', errors)
                    reject()
                }else{
                    console.log('Error in get txHook', error)
                    reject()
                }
            })
        })
    }
    const uploadTxFile = (month,year,file) => {
        return new Promise((resolve, reject) => {
            let formData = new FormData();
            formData.append('date', new Date(year, month -1).toLocaleDateString("en-ZA"))
            formData.append('file-type', file[0].name.split('.')[file[0].name.split('.').length - 1])
            formData.append('file', file[0])
            ajaxInstance.post(
                sendTxsFileUrl,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    },
                    timeout: 60000
                }
            ).then((response) => {
                const data = response.data
                console.log('Post txHook', data.data)
                if (response.status === 200){
                    resolve(data.data)
                }
            }).catch((error) => {
                console.log(error)
                if (error.response.status !== 500){
                    const data = error.response.data
                    const errors = data.errors
                    console.log('Error in post txHook', errors)
                    reject(errors)
                }else{
                    console.log('Error in post txHook', error)
                    reject('Ocurrió un problema')
                }
            })
        })
    }

    return {
        getAllTx,
        uploadTxFile
    }

}